<template>
  <div>


    <PWAPrompt v-if="shown" :install-event="installEvent" />

    <div class="container-fluid">

      <div v-if="isMobile" class="row vh-100" style="    min-height: calc(var(--vh, 1vh)*100);margin: 0px;">

        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex d-sm-flex d-md-flex d-md-flex d-lg-flex d-xl-flex justify-content-center text-center align-items-center">
          <div class="row align-items-center w-100">
            <div class="col-12">
              <img src="../../src/assets/img/logo_login.png" class="logo-login logo-login--mobile" alt="Logo" />


              <formulario :is-login="isLogin" :texto-button="textoButton" />


              <hr class="horizontal dark" style="margin-top:35px" />

              <a target="_blank" title="Facebook de EQPay" href="https://www.facebook.com/"> <i
                  class="fab fa-facebook-f redes" aria-hidden="true"></i> </a>
              <a target="_blank" title="Instagram de EQPay" href="https://www.instagram.com/"> <i
                  class="fab fa-instagram redes" aria-hidden="true"></i> </a>
              <a target="_blank" title="Email de EQPay"
                href="mailto:hola@xtrimproec.com?Subject=Tengo%20una%20pregunta"> <i class="fas fa-envelope redes"
                  aria-hidden="true"></i> </a>


              <a target="_blank" title="Linea de WhatSivo" href="https://wa.me/593985067512"> <i
                  class="fab fa-whatsapp redes" aria-hidden="true"></i> </a>


              <p style="margin-top: 10px; margin-bottom:0; font-size: 12px;"> <a href="#" target="_blank">Términos y
                  condiciones</a> - <a href="#" target="_blank">Política de privacidad y condiciones de servicios</a> -
                <a href="#" target="_blank">Reclamos</a>
              </p>

              <p style="margin-top: 0px; font-size: 12px;    margin-bottom: 10px;"> Copyright &copy; {{ year }} <a
                  href="https://app-whatsivo.com" target="_blank">- WhatSivo</a></p>




            </div>
          </div>
        </div>






      </div>

      <div v-else class="row vh-100" style="    min-height: calc(var(--vh, 1vh)*100);margin: 0px;">

        <div style="padding:0px;     height: 100vh;"
          class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 d-none d-sm-none d-md-none d-md-none d-lg-flex d-xl-flex justify-content-center align-items-center">
          <v-lazy-image :src="photo" style="object-fit: cover;object-position: top;height: 100%;width: 100%;" />

        </div>



        <div
          class="login-panel col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 d-flex flex-column justify-content-center text-center">
          <div class="login-panel__content">
              <img src="../../src/assets/img/logo_login.png" class="logo-login" alt="Logo" />

              <formulario :is-login="isLogin" :texto-button="textoButton" />

              <hr class="horizontal dark login-panel__divider" />

              <div class="login-social">
                <a target="_blank" title="Facebook de WhatSivo" href="https://www.facebook.com/whatsivo/">
                  <i class="fab fa-facebook-f redes" aria-hidden="true"></i>
                </a>
                <a target="_blank" title="Instagram de WhatSivo" href="https://instagram.com/whatsivo?igshid=OTJhZDVkZWE=">
                  <i class="fab fa-instagram redes" aria-hidden="true"></i>
                </a>
                <a target="_blank" title="Email de WhatSivo" href="#">
                  <i class="fas fa-envelope redes" aria-hidden="true"></i>
                </a>
                <a target="_blank" title="Linea de WhatSivo" href="https://wa.me/593985067512">
                  <i class="fab fa-whatsapp redes" aria-hidden="true"></i>
                </a>
              </div>

              <p class="login-legal">
                <a href="#" target="_blank">Términos y condiciones</a>
                <span> · </span>
                <a href="#" target="_blank">Política de privacidad y condiciones de servicios</a>
                <span> · </span>
                <a href="#" target="_blank">Reclamos</a>
              </p>

              <p class="login-copy">
                Copyright &copy; {{ year }}
                <a href="https://www.whatsivo.com" target="_blank">- WhatSivo</a>
              </p>
          </div>
        </div>




      </div>

    </div>

  </div>
</template>


<script>
/*eslint-disable */

import Formulario from "./Formulario.vue";
import PWAPrompt from "./PWAPrompt.vue";

export default {
  name: "signin",
  components: {
    Formulario,
    PWAPrompt
  },
  data() {
    return {
      isLogin: true,
      textoButton: "Iniciar sesión",
      year: new Date().getFullYear(),
      isMobile: this.$isMobile,
      photo: "/img/medicos-portada.jpg",
      shown: false,
      installEvent: null,
    }
  },
  beforeMount() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.installEvent = e
      this.shown = true
    })
  },
  mounted() {

    document.body.classList.remove('dark-version')

    this.$eventBus.on('ocultarPWA', () => {
      this.shown = false
    });

    document.title = 'Urmedical';


    let userData = JSON.parse(localStorage.getItem("userData"));
    let revisaSesion = userData ? userData.displayName : null;

    console.log('revisaSesion: ' + revisaSesion);

    if(revisaSesion != ""){

      this.$router.push({ name: 'Dashboard' })
    }

  },
  methods: {


  },
  created() {


  },
  beforeUnmount() {

  },
};
</script>

<style scoped>
.container-fluid {
  padding: 0px;
  margin: 0px;
}

.logo-login {
  width: 260px;
  max-width: 100%;
  height: auto;
}

.logo-login--mobile {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0 auto 0.35rem;
}

.row > .login-panel {
  justify-content: safe center;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1.75rem 1.35rem;
}

.login-panel__content {
  width: 100%;
  margin: 0 auto;
}

.login-panel .logo-login {
  display: block;
  width: 100%;
  max-width: 180px;
  margin: 0 auto 0.25rem;
}

@media (max-width: 991.98px) {
  .login-panel .logo-login,
  .logo-login.logo-login--mobile {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 0 auto 0.35rem;
  }
}

.login-panel__divider {
  margin: 1.25rem 0 1rem;
}

.login-social {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.login-social .redes {
  margin-right: 0;
  font-size: 1.2rem;
}

.login-legal,
.login-copy {
  margin: 0.7rem 0 0;
  font-size: 11px;
  line-height: 1.45;
}

.login-copy {
  margin-top: 0.35rem;
  margin-bottom: 0;
}
</style>